

<template>
    
        <div class="footerbox"> 
            <div class="index-width"> 
                <div class="fott-box2"> 
                    <div class="box2-right">
                        <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2023020153号-1</a>|CopyRight© 2023 Tellus Power集团</span>
                    </div> 
                </div> 
            </div> 
        </div> 
   
</template>

<script>
    export default {
        name: "footerNew",
        props:{
          
        },
        data(){
            return{

            }
        },
        methods:{

        }
    }
</script>

<style>
a {
    color: #20366f;
    text-decoration: none;
}
    .footerbox {
        margin: 0 auto;
        width: 100%;
        overflow: hidden;
        background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
    }

    .footerbox .fott-box2 {
        width: 100%;
        float: left;
        height: 50px;
    }
    .footerbox .fott-box2 .box2-right span {
        font-size: 14px;
        color: #181818;
        margin: 0 15px;
    }
    .footerbox .fott-box2 .box2-right {
        float: right;
        line-height: 50px;
        color: #e4e4e4;
        font-family: Tahoma;
    }
</style>